import React, { useState } from "react";
import logo from "assets/images/login-image.png";
import Input from "components/common/Input";
import Button from "components/common/Button";
import api from "config/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "hooks/store";
import { setAdminData } from "store/slices/admin.slice";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import HomeIcon from "@mui/icons-material/Home";

const LoginAdmin = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState({
    userName: "",
    password: "",
  });
  const { settings, companyData } = useAppSelector(({ main }) => main);

  const handleSubmit = () => {
    toast.dismiss();
    if (!data.userName) {
      toast.error("UserName is required");
      return;
    }
    if (!data.password) {
      toast.error("Password is required");
      return;
    }
    setLoading(true);
    api(`/api/User/ValidateUser?${new URLSearchParams(data)}`)
      .then(({ data }) => {
        dispatch(setAdminData(data));
        toast.success("Login Successfully");
        navigate("/admin/setting/time");
      })
      .catch((e) => {
        toast.error("Invalid Username or Password");
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="h-screen">
      <div className="h-[60px] bg-primary px-[20px] flex items-center  shadow-[0px_10px_10px_5px_#00000024] z-10 justify-between">
        <div className="flex justify-center items-center">
          {settings?.showLogo !== 0 ? (
            <div
              onDoubleClick={() => {
                window.location.href = "/admin/setting/time";
              }}
              className="text-white !px-1.5 relative"
            >
              <img
                src={companyData?.logoUrl}
                alt=""
                className="h-14 w-14 rounded-md mr-3"
              />
            </div>
          ) : (
            <div
              onDoubleClick={() => {
                window.location.href = "/admin/setting/time";
              }}
              className="text-white !px-1.5 relative"
            >
              <AdminPanelSettingsIcon className="text-white" />
            </div>
          )}

          {!!settings.ShowCompanyName && !!companyData?.companyName && (
            <h1 className="text-xl font-bold text-black">
              {companyData?.companyName}
            </h1>
          )}
        </div>
        <div>
          <Button
            className="bg-white !text-dark-text !px-2 relative"
            onClick={() => {
              navigate("/");
              window.location.reload();
            }}
          >
            <HomeIcon className="!text-black cursor-pointer" />
          </Button>
        </div>
      </div>
      <div className="bg-background h-screen flex justify-center items-center">
        <div className="bg-white rounded-xl overflow-hidden flex gap-2 py-8 lg:py-2 px-6">
          <div className="flex max-md:hidden">
            <img src={logo} className="h-[200px] lg:h-[350px]" alt="" />
          </div>
          <div className="flex flex-col gap-2 justify-center items-center px-8">
            <h6 className="font-bold text-primary text-xl">
              LOGIN ADMIN TO RANGER ONLINE
            </h6>
            <Input
              size="small"
              label="Username"
              variant="standard"
              value={data.userName}
              sx={{ minWidth: [200, 270] }}
              onValueChange={(userName) => setData((e) => ({ ...e, userName }))}
            />
            <Input
              size="small"
              label="Password"
              type="password"
              variant="standard"
              value={data.password}
              sx={{ minWidth: [200, 270] }}
              onValueChange={(password) => setData((e) => ({ ...e, password }))}
            />
            {/* <div className="self-end">
            <p className="text-[12px] text-primary font-semibold">
              Forget password?
            </p>
          </div> */}
            <Button
              disabled={loading}
              className="mt-6 w-full"
              onClick={handleSubmit}
            >
              LOGIN
            </Button>
            {/* <p className="text-[13px]">
            Don't have an account?{" "}
            <a href="/register" className="font-bold text-primary">
              Register
            </a>
          </p> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginAdmin;
